

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { notification } from 'antd';
import { errorCloseReducer } from '../../Components/App/Reducer/AppReducer';

export class Errors extends Component {
    componentDidMount() {
        this.showErrorNotification();

    }

    showErrorNotification = () => {
        notification.error({
            message: 'System Error',
            description: 'An unexpected error has occurred. Please try again later. This issue has been reported to our IT team.',
            duration: 5,  // Bildirimin ekranda kalma süresi (saniye)
            showProgress: true,

        });

        this.props.errorCloseReducer()
    }

    render() {
        return (
            <></>
        )
    }
}

const mapStateToProps = (state) => ({
    Apps: state.Apps
})

const mapDispatchToProps = {

    errorCloseReducer
}

export default connect(mapStateToProps, mapDispatchToProps)(Errors)